module.exports = __webpack_public_path__ + "static/carrotIcon-8d967b019c243c24319ecf989d528f83.png";